import { useContext, useEffect } from "react";

import { ContentLoadingContext } from "./ContentLoadingProvider";

/**
 * Hook to access the ContentLoadingContext.
 *
 * @param {React.ReactNode} loadingComponent - Optional loading component to set
 * @throws {Error} If used outside of ContentLoadingProvider
 * @returns {Object} The content loading context value containing setLoadingComponent
 */
export const useContentLoading = (loadingComponent) => {
  const contentLoadingContextValues = useContext(ContentLoadingContext);

  if (!contentLoadingContextValues) {
    throw new Error("useContentLoading must be used within a ContentLoadingProvider");
  }

  const { setLoadingComponent } = contentLoadingContextValues;

  useEffect(() => {
    setLoadingComponent(loadingComponent);
  }, [loadingComponent]);

  return contentLoadingContextValues;
};
